module.exports = __webpack_public_path__ + "static/media/Dratini_gaussian2.d20296f6.png";